module.exports = __webpack_public_path__ + "static/san-francisco-golden-gate-bridge-61ab99de64c759615fc213aa0da1b4fa.png";